// Exact nonnegative integer-cent display rounding; never price a line from this.
export function roundedUnitCents(lineCents,quantity) {
  if(!Number.isSafeInteger(lineCents)||lineCents<0||!Number.isSafeInteger(quantity)||quantity<=0)return null;
  const amount=BigInt(lineCents),count=BigInt(quantity);
  return Number(amount/count+(2n*(amount%count)>=count?1n:0n));
}
